import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTOp() {

    const { patchname } = useLocation();

    useEffect(() => {
        window.scrollTo(0,0);
    }, [patchname]);

    return null;
}